import React from 'react';
import { ShieldCheck } from 'lucide-react';
export const Guarantee: React.FC = () => {
  return <section className="px-4 pb-16 md:pb-24 max-w-3xl mx-auto" data-id="element-137">
      <div className="bg-cream-card rounded-2xl p-8 md:p-10 border-2 border-sage shadow-sm relative overflow-hidden" data-id="element-138">
        <div className="absolute -right-10 -top-10 text-sage/10" data-id="element-139">
          <ShieldCheck size={160} data-id="element-140" />
        </div>

        <div className="relative z-10" data-id="element-141">
          <div className="flex items-center gap-3 mb-6" data-id="element-142">
            <ShieldCheck className="text-sage shrink-0" size={32} data-id="element-143" />
            <h2 className="font-serif text-2xl md:text-3xl text-earth font-bold" data-id="element-144">
              Tu descanso está garantizado por 7 días
            </h2>
          </div>

          <div className="font-sans text-earth-light space-y-4 leading-relaxed" data-id="element-145">
            <p data-id="element-146">
              Estamos tan seguros de la efectividad del{' '}
              <strong className="text-earth" data-id="element-147">
                Método de Sustitución Proactiva
              </strong>
              , que te ofrecemos una garantía total. Descargá la guía, aplicá el
              Protocolo de Gravedad Cero esta misma noche y usá el Manual del
              Mate Seguro mañana a la mañana.
            </p>
            <p data-id="element-148">
              Si en 7 días sentís que no aprendiste nada nuevo, que la
              información no está adaptada a tu realidad o que no sentís ni un
              mínimo de alivio en tu acidez nocturna, te devolvemos el 100% de
              tu dinero. Sin vueltas y sin preguntas incómodas. Tu paz mental —y
              tu sueño— son lo primero.
            </p>
          </div>
        </div>
      </div>
    </section>;
};